module.exports = require("./ps.d.ts");